import { FC, ReactNode } from 'react';
import GradientSpot from '@/assets/images/ellipse40.svg';
import GradientSpotBottomRight from '@/assets/images/ellipse39.svg';

interface BackgroundProps {
  children: ReactNode;
}

const Background: FC<BackgroundProps> = ({ children }) => {
  return (
    <div className="bg-white relative w-full min-h-full h-full">
      {/* Children */}
      <div className="relative z-0 w-full h-full">{children}</div>

      {/* Top-Left Gradient Spot */}
      <div className="absolute m-auto -left-60 -top-40 overflow-hidden pointer-events-none -z-10">
        <img
          src={GradientSpot}
          alt=""
          className="w-full"
        />
      </div>

      {/* Bottom-Right Gradient Spot */}
      <div className="absolute bottom-0 right-0 overflow-hidden pointer-events-none -z-10">
        <img
          src={GradientSpotBottomRight}
          alt="Bottom Right Gradient Spot"
          className="w-full h-full"
        />
      </div>
    </div>
  );
};

export { Background };
